import { styled } from '@mui/material';

const StyledDial = styled('svg')(({ theme }) => ({
  flexGrow: 0,
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: theme.palette.grey[50],
  borderRadius: '100%',
  cursor: 'pointer',
  width: '100%',
}));

export default StyledDial;
